import playlist from "./PlayList";
const audio = document.querySelector(".audio");
let isPlay = false;
const player = document.querySelector(".play");
const playPrev = document.querySelector(".play-prev");
const playNext = document.querySelector(".play-next");
const playListContainer = document.querySelector(".play-list");
let playNum = 0;

function playAudio() {
  audio.src = playlist[playNum].src;
  audio.currentTime = 0;
  if (!isPlay) {
    audio.play();
    isPlay = true;
  }
  //audio.pause();
  //isPlay = false;
}
function addItemToPlayList() {
  playlist.forEach((el) => {
    const li = document.createElement("li");
    li.classList.add("play__item");
    li.textContent = playlist[playNum].title;
    playListContainer.append(li);
  });
}
addItemToPlayList();
export { playAudio };
